import AbstractAPI from '@/services/api/AbstractAPI';

export default class LeadSendTokenApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/lead-send-token');
  }

  getZohoToken(code) {
    return this.makeRequest(`/zoho/?code=${code}`, 'post');
  }
}
